import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API, SCOPE_CRM_NOTES } from '../../constants';
import { application } from '../../services/application';
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common';
import { extendListBuilder, generateListActions } from '../helpers/listActionsHelpers';

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['eventDate', 'desc'],
  params: {},
  savePending: false,
  selectedNote: null,
  notePending: false,
};

const listActions = generateListActions({
  scope: SCOPE_CRM_NOTES,
  apiMethod: {
    GET_LIST: API.CRM_NOTES.GET_LIST,
  },
  getStore: (store) => store.crmNotes,
});

export const clearSelectedNote = createAction(`${SCOPE_CRM_NOTES}/clearSelectedNote`);

export const fetchNote = createAsyncThunk(`${SCOPE_CRM_NOTES}/fetchNote`, (params) => {
  return application.call(API.CRM_NOTES.FIND_ONE, params);
});

export const createNote = createAsyncThunk(`${SCOPE_CRM_NOTES}/createNote`, (params) => {
  return application.call(API.CRM_NOTES.CREATE, params);
});

export const actions = {
  ...listActions,
  clearSelectedNote,
  fetchNote,
  createNote,
};

export default createReducer(INITIAL_STATE, (builder) => {
  extendListBuilder(builder, actions);

  builder
    .addCase(fetchNote.pending, (state) => {
      state.notePending = true;
    })
    .addCase(fetchNote.fulfilled, (state, action) => {
      state.selectedNote = action.payload;
      state.notePending = false;
    })
    .addCase(fetchNote.rejected, (state) => {
      state.selectedNote = null;
      state.notePending = false;
    })
    .addCase(createNote.pending, (state) => {
      state.savePending = true;
    })
    .addCase(createNote.fulfilled, (state) => {
      state.savePending = false;
    })
    .addCase(createNote.rejected, (state) => {
      state.savePending = false;
    })
    .addCase(clearSelectedNote, (state) => {
      state.selectedNote = null;
      state.notePending = false;
    });
});
